import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TranslationLocale } from '../../../../../lib/types/enums/translation/translation.enum'
import { OptionInput } from '../../../../../lib/types/models/options/option-input'
import { BaseFormProps } from '../../../../../lib/types/utils'
import { getSubmitAction } from '../../../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../../../lib/utils/validations/string-validation'
import { createTranslationsSchema } from '../../../../../lib/utils/validations/translations-validation'
import { FORM_MODE } from '../../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../../elements/forms/form'
import ControlledInput from '../../../../elements/inputs/controlled-input'
import TranslationsInput from '../../../../elements/inputs/translations-input'
import ValidationButtons from '../../../../elements/validation-buttons'

type Props = BaseFormProps<OptionInput> & {
  className?: string
}

const formSchema: ZodType<OptionInput> = z.object({
  code: createStringSchema('Code', { nullish: true }),
  translations: createTranslationsSchema([TranslationLocale.FR])
})

const JourneyPlaceDuplicateOptionForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: Props) => {
  const form = useForm<OptionInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <FormField
            control={form.control}
            name="code"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} type="text" label="Code" />
                </FormControl>
              </FormItem>
            )}
          />
          <div className="h-4" />

          <TranslationsInput
            control={form.control}
            name="translations"
            label="NOM"
            requiredLocales={[TranslationLocale.FR]}
          />
        </div>
        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default JourneyPlaceDuplicateOptionForm
